import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_QUANLYTHUCHINGOAILE } from "../actions/QuanLyThuChiNgoaiLe/actionTypes";
import {
  getListQuanLyThuChiNgoaiLeSuccess,
  getListQuanLyThuChiNgoaiLeFailure,
} from "../actions/QuanLyThuChiNgoaiLe";
import { pushNotification } from "utils/notifications";
import QuanLyThuChiNgoaiLeApi from "../service/quanLyThuChiNgoaiLeApi";

function* getListQuanLyThuChiNgoaiLe(action) {
  try {
    const response = yield call(QuanLyThuChiNgoaiLeApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListQuanLyThuChiNgoaiLeSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListQuanLyThuChiNgoaiLeFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListQuanLyThuChiNgoaiLeFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_QUANLYTHUCHINGOAILE, getListQuanLyThuChiNgoaiLe);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
